module.exports = __webpack_public_path__ + "static/media/disc-drive.3de1e73d.svg";